module.exports = __webpack_public_path__ + "img/HC3012-90.e702e504.jpg";